import { create } from "zustand";

interface GlobalSearchState {
  search: string;
  setSearchText: (prop: string) => void;
  progress: boolean;
  setSearchProgress: (prop: boolean) => void;
}

export const useGlobalSearch = create<GlobalSearchState>((set) => ({
  search: "",
  progress: false,
  setSearchText: (value) => set(() => ({ search: value })),
  setSearchProgress: (value) => set(() => ({ progress: value })),
}));
